function EnrolleeSafeLabel(){
    this.__type = 'EnrolleeSafeLabel:www.veritracks.com';
    this.Id = -1;
    this.EnrolleeId =0;
    this.ZoneId =0;
    this.DeviceId = 0;
    this.AddressId =0;
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeSafeLabel;
}